import { CabinClass } from "@common/models";
import  { CSSProperties, FC } from "react";

interface ISeatProps {
    id?: string;
    className?: string;
    style?: CSSProperties;
    size: "small" | "medium" | "large" | "auto";
    status: "free" | "reserved" | "selected";
    cabinClass?: CabinClass;
}

const Seat: FC<ISeatProps> = (props) => {
    const { id, className, size, style, status } = props;

    return (
        <span id={id} style={style} className={`seat ${size} ${status}${className ? ` ${className}` : ''}`}>
            <span className={`inner-seat en`}>
                {props.children}
            </span>
        </span>
    )
}

export default Seat;